var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConsulting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_linear_messages",
    "data-name": "vuesax/linear/messages",
    transform: "translate(-556 -314)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "messages",
    transform: "translate(556 314)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.583 4.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.651,3.792V6.959a4.8,4.8,0,0,1-.032.594c-.182,2.138-1.441,3.2-3.76,3.2H8.542A.637.637,0,0,0,8.035,11l-.95,1.267a.9.9,0,0,1-1.52,0L4.615,11a.731.731,0,0,0-.507-.253H3.792C1.267,10.751,0,10.125,0,6.959V3.792C0,1.473,1.069.214,3.2.032A4.8,4.8,0,0,1,3.792,0H8.859Q12.647,0,12.651,3.792Z",
    fill: "none",
    stroke: "#161617",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M12.619,3.792V6.959q0,3.491-3.2,3.76a4.8,4.8,0,0,0,.032-.594V6.959q0-3.788-3.792-3.792H.594A4.8,4.8,0,0,0,0,3.2C.182,1.069,1.441,0,3.76,0H8.827Q12.615,0,12.619,3.792Z",
    transform: "translate(4.782 1.583)",
    fill: "none",
    stroke: "#161617",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H19V19H0Z",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M.5.5H.5",
    transform: "translate(10.188 9.99)",
    fill: "none",
    stroke: "#161617",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M.5.5H.5",
    transform: "translate(7.418 9.99)",
    fill: "none",
    stroke: "#161617",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M.5.5H.5",
    transform: "translate(4.647 9.99)",
    fill: "none",
    stroke: "#161617",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsulting);
export default __webpack_public_path__ + "static/media/consulting.8b33e800404faeafc6f2627f8d7e14b6.svg";
export { ForwardRef as ReactComponent };